/**
 * prism.js tomorrow night eighties for JavaScript, CoffeeScript, CSS and HTML
 * Based on https://github.com/chriskempson/tomorrow-theme
 * @author Rose Pritchard
 */

 .prism-code-editor {
	 font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #aeafad;
	--pce-bg: #2d2d2d;
	--pce-widget-border: #444;
	--pce-widget-bg: #252526;
	--pce-widget-color: #ccc;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #aaa;
	--pce-widget-bg-input: #3c3c3c;
	--pce-widget-bg-hover: #5a5d5e80;
	--pce-widget-bg-active: #007fd466;
	--pce-widget-focus: #007acc;
	--pce-search-match: #eb5e0054;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #393939;
	--pce-selection-match: #41414199;
	--pce-line-number: #888;
	--pce-scrollbar: 0, 0%, 50%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #9994;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #515151;
	color-scheme: dark;
}

.match-highlight {
	--pce-bg-highlight: #282828;
}

.pce-match {
	--pce-search-match: #515c6a;
}

.active-line {
	--pce-line-number: #ccc;
}

.active-indent {
	--pce-guide-indent: #eee6;
}

[class*="language-"],
.token.punctuation,
.token.attr-equals {
	color: #ccc;
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #999;
}

.token.tag,
.token.attr-name,
.token.namespace,
.token.deleted {
	color: #e2777a;
}

.token.function-name {
	color: #6196cc;
}

.token.boolean,
.token.number,
.token.function {
	color: #f08d49;
}

.token.property,
.token.class-name,
.token.constant,
.token.symbol {
	color: #f8c555;
}

.token.selector,
.token.important,
.token.atrule,
.token.keyword,
.token.builtin {
	color: #cc99cd;
}

.token.string,
.token.char,
.token.attr-value,
.token.regex,
.language-regex,
.token.variable {
	color: #7ec699;
}

.token.operator,
.token.entity,
.token.url {
	color: #67cdcc;
}

.token.important,
.token.bold {
	font-weight: bold;
}
.token.italic {
	font-style: italic;
}

.token.inserted {
	color: green;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #888, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #575757b8;
}
